import script from "./DeviceManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&setup=true&lang=js"

import "./DeviceManagement.vue?vue&type=style&index=0&id=365d810e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365d810e"]])

export default __exports__